module.exports = __webpack_public_path__ + "static/media/homen-arena.770fcda6.png";